// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.project-details {
  padding: 1rem;
  border: 1px solid #d7dee8;
}
.project-details__caption {
  color: #5a6878;
  font-size: 1rem;
  font-weight: 300;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  margin-bottom: 0.25rem;
}
.project-details__value {
  color: #1f2d3d;
  font-size: 1.2rem;
  font-weight: 500;
  line-height: 1.35;
  word-break: break-word;
}
.project-details__title {
  font-size: 1.2rem;
  font-weight: 1000;
}
.project-details__error {
  color: #8a1f17;
  font-weight: 600;
}

.project-details-loading {
  min-height: 72px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/project-details/project-details.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,yBAAA;AACF;AACE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,sBAAA;AACJ;AAEE;EACE,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;AAAJ;AAGE;EACE,iBAAA;EACA,iBAAA;AADJ;AAIE;EACE,cAAA;EACA,gBAAA;AAFJ;;AAMA;EACE,gBAAA;AAHF","sourcesContent":[".project-details {\n  padding: 1rem;\n  border: 1px solid #d7dee8;\n\n  &__caption {\n    color: #5a6878;\n    font-size: 1rem;\n    font-weight: 300;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    margin-bottom: 0.25rem;\n  }\n\n  &__value {\n    color: #1f2d3d;\n    font-size: 1.2rem;\n    font-weight: 500;\n    line-height: 1.35;\n    word-break: break-word;\n  }\n\n  &__title {\n    font-size: 1.2rem;\n    font-weight: 1000;\n  }\n\n  &__error {\n    color: #8a1f17;\n    font-weight: 600;\n  }\n}\n\n.project-details-loading {\n  min-height: 72px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
